// extracted by mini-css-extract-plugin
export default {"inner":"Loader_inner__cOPyg","loader":"Loader_loader__DwtSp","full-page":"Loader_full-page__fOj2A","editor":"Loader_editor__7Gru9","card":"Loader_card__fWfj+"};